import React, { FC, useMemo } from "react";
import { Field, useFormState } from "react-final-form";
import { Grid } from "@material-ui/core";
import FieldsGroupLabel from "../common/FieldsGroupLabel";
import Autocomplete from "../../../../../components/Autocomplete";
import { CATEGORIES } from "../../../constants";
import { ICourseComponentProps } from "../../../types";

interface ICategoryProps extends ICourseComponentProps {
  disabled?: boolean;
}

const Category: FC<ICategoryProps> = ({
  fieldsGroupName,
  errors,
  disabled = false,
}) => {
  const { values } = useFormState();
  const language = values?.[fieldsGroupName]?.language;
  const categories = useMemo(() => CATEGORIES[language?.id] ?? [], [language]);

  return (
    <div>
      <FieldsGroupLabel
        isRequired
        label="Category"
        hasError={!!errors?.category}
        className="fields-group-label"
      />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <Field
            fullWidth
            disabled={disabled}
            options={categories}
            freeSolo
            autoSelect
            placeholder="Please enter or select"
            name={`${fieldsGroupName}.category`}
            component={Autocomplete}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default React.memo(Category);
